import * as React from 'react'

export function Text({value, style}) {
  return <span style={style}>{value}</span>
}
